import { FormControl, FormGroup } from '@angular/forms';

import { FormType } from './types';

export const createForm = () => {
  return new FormGroup<FormType>({
    isPublic: new FormControl(true, { nonNullable: true }),
    grantedUsers: new FormControl([], { nonNullable: true }),
  });
};
